/* =====================================================
   AMK STREAM STORE — Frontend (Phase 4)
   Twitch-Login (Implicit Flow) -> Punktestand -> Artikel -> Einlösen.
   Konfig kommt aus window.AMK_STORE_CONFIG (amk-store.liquid).
   Nutzt supabase-js (CDN) + Twitch Helix.
===================================================== */
(function () {
  "use strict";
  const CFG = window.AMK_STORE_CONFIG || {};
  const root = document.getElementById(CFG.rootId || "amkStoreRoot");
  if (!root) return;

  const TW_CLIENT = CFG.twitchClientId;
  const REDIRECT = CFG.redirectUri || (location.origin + location.pathname);
  const LS_KEY = "amk_store_session";

  let sb = null;
  try { sb = window.supabase.createClient(CFG.supabaseUrl, CFG.supabaseKey); } catch (e) {}

  let session = null;     // { id, login, name, avatar }
  let settings = {};
  let items = [];
  let viewer = null;      // store_viewers row
  let top = [];           // Top-Zuschauer (Leaderboard)
  let myReds = [];        // eigene Einlösungen (Verlauf)
  let recentReds = [];    // letzte Einlösungen ALLER Zuschauer (Social Proof)
  let activeCat = "Alle"; // aktiver Kategorie-Filter

  const esc = (s) => String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const pts = (n) => Number(n || 0).toLocaleString("de-DE");

  // Twitch-Glyph fürs Login
  const TWITCH_IC = `<svg class="ic" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4.3 0 1 3.3v17.4h5.7V24l3.3-3.3h4.7L22 14V0H4.3Zm15.4 13-3.3 3.3h-4.7L8.7 19v-2.7H5V2h14.7v11ZM15.7 5h-2v6h2V5Zm-5.4 0h-2v6h2V5Z"/></svg>`;

  // Animierter Punkte-Zähler (count-up)
  let lastPoints = 0;
  function animateCount(el, to) {
    if (!el) return;
    const from = Number(lastPoints) || 0;
    to = Number(to || 0);
    lastPoints = to;
    if (from === to) { el.textContent = pts(to); return; }
    const dur = 850, t0 = performance.now();
    const ease = (x) => 1 - Math.pow(1 - x, 3);
    (function step(now) {
      const k = Math.min(1, (now - t0) / dur);
      el.textContent = pts(Math.round(from + (to - from) * ease(k)));
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  function skeletons(n = 6) {
    return `<div class="amk-store-grid">${Array.from({ length: n }).map(() =>
      `<div class="amk-store-skel-card"><div class="amk-store-skel-img"></div><div class="amk-store-skel-line"></div><div class="amk-store-skel-line sm"></div></div>`
    ).join("")}</div>`;
  }

  // Fallback-Avatar (für Zuschauer ohne Twitch-Profilbild, z.B. per Giveaway angelegt)
  const AVA_FALLBACK = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='64' height='64'%3E%3Crect width='64' height='64' rx='32' fill='%231b202c'/%3E%3Ctext x='32' y='44' font-size='30' fill='%23f4cd6a' font-family='sans-serif' font-weight='700' text-anchor='middle'%3E%E2%98%85%3C/text%3E%3C/svg%3E";

  const isMe = (v) => session && String(v.twitch_login || "").toLowerCase() === String(session.login || "").toLowerCase();

  /* ---------- Sidebar: Top Gewinner ---------- */
  function sideboard() {
    if (!top.length) return "";
    const rows = top.slice(0, 8).map((v, i) => `
      <div class="amk-store-rank ${i === 0 ? "top1" : ""}${isMe(v) ? " me" : ""}">
        <span class="rk">${i + 1}</span>
        <img class="rk-ava" src="${esc(v.avatar_url || AVA_FALLBACK)}" onerror="this.src='${AVA_FALLBACK}'" alt="">
        <span class="rk-name">${esc(v.display_name || v.twitch_login || "—")}</span>
        <span class="rk-pts">⭐ ${pts(v.points)}</span>
      </div>`).join("");
    return `<div class="amk-store-board">
        <div class="amk-store-board-head"><h2>🏆 Top Gewinner</h2></div>
        <div class="amk-store-board-list">${rows}</div>
      </div>`;
  }

  /* ---------- Featured "Bretter" (Top-Artikel mit PNG) ---------- */
  function featuredBoard(it) {
    const canAfford = viewer && Number(viewer.points || 0) >= Number(it.price_points || 0);
    const soldOut = it.stock != null && it.stock <= 0;
    let label = "Jetzt einlösen", disabled = "";
    if (soldOut) { label = "Ausverkauft"; disabled = "disabled"; }
    else if (!session) { label = "Login zum Einlösen"; }
    else if (!canAfford) { label = "Zu wenig Punkte"; disabled = "disabled"; }
    const sub = it.description || `Sichere dir „${it.name}" mit nur ${pts(it.price_points)} Punkten.`;
    return `<article class="amk-store-feat">
        ${it.stock != null ? `<span class="amk-store-feat-stock">${it.stock} übrig</span>` : ""}
        <div class="amk-store-feat-body">
          <span class="amk-store-feat-tag">★ ${esc(it.category || "Featured")}</span>
          <h2>${esc(it.name)}</h2>
          <p>${esc(sub)}</p>
          <div class="amk-store-feat-foot">
            <span class="amk-store-feat-price">⭐ ${pts(it.price_points)} Punkte</span>
            <button class="amk-store-btn gold" data-redeem="${esc(it.id)}" data-email="${it.requires_email ? "1" : "0"}" ${disabled}>${label}</button>
          </div>
        </div>
        <div class="amk-store-feat-media">
          <div class="amk-store-feat-glow"></div>
          <img class="amk-store-feat-png" src="${esc(it.image_url || "")}" alt="" onerror="this.style.display='none'">
        </div>
      </article>`;
  }

  /* ---------- Eigene Einlösungen (langgezogene Cards) ---------- */
  function myRedCard(r) {
    const st = r.status || "pending";
    const lbl = st === "completed" ? "Erledigt" : st === "cancelled" ? "Storniert" : "In Bearbeitung";
    const it = items.find((x) => x.id === r.item_id);
    const img = (it && it.image_url) || AVA_FALLBACK;
    let when = ""; try { when = new Date(r.created_at).toLocaleDateString("de-DE"); } catch (e) {}
    return `<div class="amk-store-red">
        <img class="amk-store-red-img" src="${esc(img)}" onerror="this.src='${AVA_FALLBACK}'" alt="">
        <div class="amk-store-red-main"><strong>${esc(r.item_name || "—")}</strong><small>⭐ ${pts(r.price_points)}${when ? " · " + when : ""}</small></div>
        <span class="amk-store-red-badge ${st}">${lbl}</span>
      </div>`;
  }

  /* ---------- Scroll-Reveal ---------- */
  function observeReveal() {
    const els = root.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) { els.forEach((e) => e.classList.add("in")); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach((e, i) => { e.style.transitionDelay = Math.min(i, 6) * 60 + "ms"; io.observe(e); });
  }

  /* ---------- 3D-Scroll der Featured-Bretter ---------- */
  let s3dRaf = false;
  function update3D() {
    s3dRaf = false;
    const vh = window.innerHeight || 800, mid = vh / 2;
    root.querySelectorAll(".amk-store-feat").forEach((el) => {
      const r = el.getBoundingClientRect();
      let p = ((r.top + r.height / 2) - mid) / vh;   // -1 (oben) .. +1 (unten)
      p = Math.max(-1, Math.min(1, p));
      const png = el.querySelector(".amk-store-feat-png");
      if (png) png.style.transform =
        `rotateY(${p * -16}deg) rotateX(${p * 9}deg) translateY(${p * -22}px) scale(${1 - Math.abs(p) * 0.05})`;
      el.style.opacity = String(1 - Math.min(Math.abs(p), 0.9) * 0.5);
    });
  }
  function on3D() { if (!s3dRaf) { s3dRaf = true; requestAnimationFrame(update3D); } }
  if (!window.__amkStore3Dbound) {
    window.__amkStore3Dbound = true;
    window.addEventListener("scroll", on3D, { passive: true });
    window.addEventListener("resize", on3D, { passive: true });
  }

  /* ---------- Animierter Hintergrund: Gold-Coins (K) & Poker-Chips ---------- */
  function startCoinFx() {
    if (window.__amkCoinFx) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const canvas = document.createElement("canvas");
    canvas.id = "amkStoreFx";
    root.insertBefore(canvas, root.firstChild);
    const ctx = canvas.getContext("2d");
    let W = 0, H = 0, coins = [], dpr = Math.min(window.devicePixelRatio || 1, 2), raf = 0, paused = false;

    function mk() {
      const r = 12 + Math.random() * 22;
      return {
        x: Math.random() * W, y: Math.random() * H, r,
        vy: -(0.12 + Math.random() * 0.34), vx: (Math.random() - 0.5) * 0.16,
        rot: Math.random() * Math.PI * 2, vr: (Math.random() - 0.5) * 0.012,
        chip: Math.random() < 0.42, a: 0.16 + Math.random() * 0.28,
      };
    }
    function seed() {
      const n = Math.max(14, Math.min(40, Math.round(W * H / 95000)));
      coins = []; for (let i = 0; i < n; i++) coins.push(mk());
    }
    function size() {
      W = root.clientWidth; H = Math.max(root.scrollHeight, window.innerHeight);
      canvas.width = W * dpr; canvas.height = H * dpr;
      canvas.style.width = W + "px"; canvas.style.height = H + "px";
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      seed();
    }
    function drawCoin(c) {
      ctx.save(); ctx.globalAlpha = c.a; ctx.translate(c.x, c.y); ctx.rotate(c.rot);
      const g = ctx.createLinearGradient(-c.r, -c.r, c.r, c.r);
      g.addColorStop(0, "#f7e7b0"); g.addColorStop(0.5, "#e9cd86"); g.addColorStop(1, "#b1842c");
      ctx.beginPath(); ctx.arc(0, 0, c.r, 0, 7); ctx.fillStyle = g; ctx.fill();
      ctx.lineWidth = Math.max(1, c.r * 0.12); ctx.strokeStyle = "rgba(90,62,16,.55)"; ctx.stroke();
      if (c.chip) {
        ctx.strokeStyle = "rgba(18,16,9,.5)"; ctx.lineWidth = c.r * 0.5;
        for (let i = 0; i < 6; i++) { const a = i * Math.PI / 3; ctx.beginPath(); ctx.arc(0, 0, c.r * 0.85, a - 0.14, a + 0.14); ctx.stroke(); }
        ctx.beginPath(); ctx.arc(0, 0, c.r * 0.58, 0, 7); ctx.strokeStyle = "rgba(60,42,12,.6)"; ctx.lineWidth = Math.max(1, c.r * 0.08); ctx.stroke();
      } else {
        ctx.beginPath(); ctx.arc(0, 0, c.r * 0.82, 0, 7); ctx.strokeStyle = "rgba(120,84,22,.45)"; ctx.lineWidth = Math.max(1, c.r * 0.06); ctx.stroke();
        ctx.fillStyle = "rgba(74,52,12,.92)"; ctx.font = "900 " + (c.r * 0.58).toFixed(0) + "px Inter,Arial,sans-serif";
        ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillText("AMK", 0, c.r * 0.04);
      }
      ctx.restore();
    }
    function frame() {
      if (paused) { raf = requestAnimationFrame(frame); return; }
      ctx.clearRect(0, 0, W, H);
      for (const c of coins) {
        c.y += c.vy; c.x += c.vx; c.rot += c.vr;
        if (c.y < -c.r - 10) { c.y = H + c.r + 10; c.x = Math.random() * W; }
        if (c.x < -40) c.x = W + 40; else if (c.x > W + 40) c.x = -40;
        drawCoin(c);
      }
      raf = requestAnimationFrame(frame);
    }
    size();
    window.addEventListener("resize", () => { clearTimeout(canvas._rs); canvas._rs = setTimeout(size, 200); });
    document.addEventListener("visibilitychange", () => { paused = document.hidden; });
    window.__amkCoinFx = { resize: size };
    raf = requestAnimationFrame(frame);
  }

  /* ---------- Kategorie-Leiste ---------- */
  function catBar() {
    const cats = ["Alle"].concat(Array.from(new Set(items.map((i) => i.category).filter(Boolean))));
    if (cats.length <= 1) return "";
    return `<div class="amk-store-cats">${cats.map((c) =>
      `<button type="button" class="amk-store-cat-pill${activeCat === c ? " active" : ""}" data-cat="${esc(c)}">${esc(c)}</button>`
    ).join("")}</div>`;
  }

  /* ---------- Landing-Sektionen (Aufbau wie Vorlage) ---------- */
  function heroSection() {
    const banner = CFG.bannerUrl || settings.banner_url || "";
    return `<section class="amk-store-hero reveal">
        <h1>Hol dir <b>Hardware, Merch &amp; Guthaben</b> mit deinen Stream-Punkten</h1>
        <p>Schau live zu, sammle Punkte und löse sie hier gegen echte Belohnungen ein — vom Gutschein bis zur PlayStation.</p>
        <div class="amk-store-hero-cta">
          <button type="button" class="amk-store-btn" data-scroll="catalog">Alle Produkte</button>
          <button type="button" class="amk-store-btn ghost" data-scroll="how">So funktioniert's</button>
        </div>
        <div class="amk-store-hero-banner">
          ${banner ? `<img src="${esc(banner)}" alt="">`
            : `<div class="amk-store-hero-ph"><b>Dein Banner-Bild hier</b>Im Theme-Customizer der Store-Section als „Banner-URL" setzen (z.B. dein PlayStation-Banner)</div>`}
        </div>
      </section>`;
  }

  function catTiles() {
    const cats = Array.from(new Set(items.map((i) => i.category).filter(Boolean)));
    if (!cats.length) return "";
    const tiles = cats.map((c) => {
      const first = items.find((i) => i.category === c && i.image_url);
      return `<div class="amk-store-tile" data-cat="${esc(c)}">
          <div class="amk-store-tile-bg" style="background-image:url('${esc(first ? first.image_url : "")}')"></div>
          <div class="amk-store-tile-name"><span>${esc(c)}</span><span class="arr">→</span></div>
        </div>`;
    }).join("");
    return `<section class="amk-store-section reveal">
        <div class="amk-store-sec-head"><h2>Kategorien</h2></div>
        <div class="amk-store-cat-tiles">${tiles}</div>
      </section>`;
  }

  function promoSection() {
    const img = CFG.howImageUrl || "";
    return `<section class="amk-store-section reveal" id="amkHow">
        <div class="amk-store-promo">
          <div class="amk-store-promo-media">${img ? `<img src="${esc(img)}" alt="">` : `<div class="amk-store-hero-ph"><b style="font-size:34px">🎁</b>Punkte → Belohnungen</div>`}</div>
          <div>
            <h2>So funktioniert's</h2>
            <p>In drei Schritten zu deiner Belohnung.</p>
            <ul class="amk-store-promo-list">
              <li><div class="amk-store-promo-ic">🟣</div><div><strong>1. Mit Twitch einloggen</strong><small>Ein Klick — dein Profil & Punktestand erscheinen.</small></div></li>
              <li><div class="amk-store-promo-ic">⭐</div><div><strong>2. Punkte sammeln</strong><small>Beim Zuschauen, im Chat & bei Keyword-Aktionen automatisch.</small></div></li>
              <li><div class="amk-store-promo-ic">🎁</div><div><strong>3. Einlösen</strong><small>Gutscheine, Merch, Hardware — wir liefern.</small></div></li>
            </ul>
            <button type="button" class="amk-store-btn" data-scroll="catalog">Jetzt stöbern</button>
          </div>
        </div>
      </section>`;
  }

  function footerSection() {
    return `<footer class="amk-store-footer">
        <div class="fbrand"><img src="${esc(CFG.logoUrl || "")}" alt="">AMK Stream Store</div>
        <div>© ${new Date().getFullYear()} NOURI_AMK — Punkte sammeln & einlösen</div>
      </footer>`;
  }

  function twitchSection() {
    const channel = (settings.channel_login || "Nouri_AMK");
    const ch = encodeURIComponent(channel);
    const host = encodeURIComponent(location.hostname || "nouri-amk.com");
    return `<section class="amk-store-section reveal">
        <div class="amk-store-sec-head"><h2>Live dabei sein</h2><span class="amk-store-sec-count">Punkte gibt's fürs Zuschauen</span></div>
        <div class="amk-store-twitch">
          <div class="amk-store-twitch-player">
            <iframe src="https://player.twitch.tv/?channel=${ch}&parent=${host}&muted=true&autoplay=true" allowfullscreen></iframe>
          </div>
          <div class="amk-store-twitch-side">
            <span class="amk-store-live">${TWITCH_IC} Twitch · ${esc(channel)}</span>
            <h3>Schau zu &amp; kassiere automatisch Punkte</h3>
            <p>Solange du im Stream bist, sammelst du laufend Punkte — und löst sie hier gegen echte Belohnungen ein. Verpasse keinen Drop.</p>
            <a class="amk-store-btn" href="https://twitch.tv/${ch}" target="_blank" rel="noopener">${TWITCH_IC} Auf Twitch öffnen</a>
          </div>
        </div>
      </section>`;
  }

  function recentRedemptionsSection() {
    if (!recentReds.length) return "";
    const cards = recentReds.map((r) => {
      const v = r.store_viewers || {};
      const name = v.display_name || r.twitch_login || "—";
      const ava = v.avatar_url || AVA_FALLBACK;
      let when = ""; try { when = new Date(r.created_at).toLocaleDateString("de-DE"); } catch (e) {}
      return `<div class="amk-store-rr-card">
          <div class="amk-store-rr-head"><img class="amk-store-rr-ava" src="${esc(ava)}" onerror="this.src='${AVA_FALLBACK}'" alt=""><strong>${esc(name)}</strong></div>
          <div class="amk-store-rr-item">${esc(r.item_name || "—")}</div>
          <div class="amk-store-rr-foot"><span class="pts">⭐ ${pts(r.price_points)}</span><span class="date">${when}</span></div>
        </div>`;
    }).join("");
    return `<section class="amk-store-section reveal">
        <div class="amk-store-sec-head"><h2>Zuletzt eingelöst</h2><span class="amk-store-sec-count">Wer hat sich was geholt</span></div>
        <div class="amk-store-rr">${cards}</div>
      </section>`;
  }

  /* ---------- Twitch Login ---------- */
  function loginUrl() {
    return "https://id.twitch.tv/oauth2/authorize"
      + "?client_id=" + encodeURIComponent(TW_CLIENT)
      + "&redirect_uri=" + encodeURIComponent(REDIRECT)
      + "&response_type=token&scope=";
  }
  function startLogin() { location.href = loginUrl(); }
  function logout() { localStorage.removeItem(LS_KEY); session = null; viewer = null; render(); }

  async function twitchUser(token) {
    const r = await fetch("https://api.twitch.tv/helix/users", {
      headers: { "Client-Id": TW_CLIENT, "Authorization": "Bearer " + token },
    });
    const j = await r.json();
    return j.data && j.data[0];
  }

  async function handleRedirect() {
    const h = location.hash || "";
    const m = h.match(/access_token=([^&]+)/);
    if (!m) return;
    try {
      const u = await twitchUser(m[1]);
      if (u) {
        session = { id: u.id, login: u.login, name: u.display_name, avatar: u.profile_image_url };
        localStorage.setItem(LS_KEY, JSON.stringify(session));
      }
    } catch (e) { console.warn("twitch login", e); }
    try { history.replaceState(null, "", location.pathname + location.search); } catch (e) {}
  }

  /* ---------- Daten ---------- */
  async function loadSettings() {
    try { const { data } = await sb.from("store_settings").select("*").eq("id", 1).maybeSingle(); settings = data || {}; } catch (e) {}
  }
  async function loadItems() {
    try { const { data } = await sb.from("store_items").select("*").eq("active", true).order("sort_order", { ascending: true }); items = data || []; } catch (e) { items = []; }
  }
  async function loadTop() {
    try {
      const { data } = await sb.from("store_viewers")
        .select("display_name,twitch_login,avatar_url,points")
        .order("points", { ascending: false }).limit(10);
      top = data || [];
    } catch (e) { top = []; }
  }
  async function loadMyRedemptions() {
    myReds = [];
    if (!viewer) return;
    try {
      const { data } = await sb.from("store_redemptions").select("*")
        .eq("viewer_id", viewer.id).order("created_at", { ascending: false }).limit(8);
      myReds = data || [];
    } catch (e) { myReds = []; }
  }
  async function loadRecentRedemptions() {
    try {
      const { data } = await sb.from("store_redemptions")
        .select("item_name,price_points,created_at,twitch_login,store_viewers(display_name,avatar_url)")
        .neq("status", "cancelled")
        .order("created_at", { ascending: false }).limit(12);
      recentReds = data || [];
    } catch (e) { recentReds = []; }
  }
  async function loadViewer() {
    viewer = null;
    if (!session) return;
    try {
      // 1) Bevorzugt per stabiler Twitch-User-ID
      let { data } = await sb.from("store_viewers").select("*").eq("twitch_user_id", session.id).maybeSingle();

      // 2) Fallback per Login: z.B. wenn ein Mod schon Punkte vergeben hat,
      //    BEVOR sich der Zuschauer je eingeloggt hat (Zeile ohne twitch_user_id).
      //    Diese Zeile übernehmen, statt eine zweite anzulegen -> Punkte bleiben erhalten.
      if (!data && session.login) {
        const byLogin = await sb.from("store_viewers").select("*").ilike("twitch_login", session.login).maybeSingle();
        if (byLogin.data) {
          const upd = await sb.from("store_viewers").update({
            twitch_user_id: session.id,
            display_name: session.name || byLogin.data.display_name,
            avatar_url: session.avatar || byLogin.data.avatar_url,
            updated_at: new Date().toISOString(),
          }).eq("id", byLogin.data.id).select().maybeSingle();
          data = upd.data || byLogin.data;
        }
      }

      // 3) Sonst neu anlegen
      if (!data) {
        const ins = await sb.from("store_viewers").insert({
          twitch_user_id: session.id, twitch_login: session.login,
          display_name: session.name, avatar_url: session.avatar, points: 0,
        }).select().maybeSingle();
        data = ins.data;
      }
      viewer = data;
    } catch (e) { console.warn("viewer", e); }
  }

  async function redeem(itemId, requiresEmail) {
    if (!session) { startLogin(); return; }
    let email = null;
    if (requiresEmail) {
      email = prompt("Bitte E-Mail für die Auslieferung angeben:");
      if (email === null) return;
    }
    try {
      const { data, error } = await sb.rpc("store_redeem", {
        p_twitch_user_id: session.id, p_item_id: itemId, p_email: email,
      });
      if (error) { toast(error.message, false); return; }
      const res = data || {};
      if (res.ok) {
        toast("Eingelöst! 🎉 Wir melden uns. Restpunkte: " + pts(res.points_left), true);
        await Promise.all([loadViewer(), loadTop(), loadRecentRedemptions()]); await loadMyRedemptions(); render();
      } else {
        toast(res.error || "Einlösung fehlgeschlagen", false);
      }
    } catch (e) { toast(String(e.message || e), false); }
  }

  /* ---------- UI ---------- */
  function toast(msg, ok) {
    let t = document.getElementById("amkStoreToast");
    if (!t) { t = document.createElement("div"); t.id = "amkStoreToast"; t.className = "amk-store-toast"; document.body.appendChild(t); }
    t.textContent = msg;
    t.className = "amk-store-toast " + (ok ? "ok" : "err") + " show";
    clearTimeout(t._h); t._h = setTimeout(() => { t.className = "amk-store-toast"; }, 4000);
  }

  /* ===================== GLÜCKSRAD ===================== */
  // Reihenfolge MUSS exakt zur SQL-Funktion store_gamble passen (Segment-Index 0..13)!
  const WHEEL = [
    { t: "100",     c: "#c79a3e" },
    { t: "500",     c: "#e6b85c" },
    { t: "iPhone",  c: "#8b5cf6", big: true },
    { t: "1.000",   c: "#f7df97" },
    { t: "Niete",   c: "#33333d", niete: true },
    { t: "5.000",   c: "#37e0a0" },
    { t: "100",     c: "#c79a3e" },
    { t: "10.000",  c: "#2f9e6b" },
    { t: "500",     c: "#e6b85c" },
    { t: "PS5",     c: "#2f80ed", big: true },
    { t: "1.000",   c: "#f7df97" },
    { t: "Niete",   c: "#33333d", niete: true },
    { t: "100.000", c: "#ff6b6b" },
    { t: "Xbox",    c: "#1fa45f", big: true },
  ];
  let wheelRotation = 0, wheelSpinning = false;
  function wheelPolar(cx, cy, r, deg) { const a = (deg - 90) * Math.PI / 180; return [cx + r * Math.cos(a), cy + r * Math.sin(a)]; }
  function buildWheelSvg() {
    const N = WHEEL.length, seg = 360 / N, cx = 110, cy = 110, r = 106;
    let paths = "", labels = "";
    for (let i = 0; i < N; i++) {
      const a0 = i * seg, a1 = (i + 1) * seg;
      const [x0, y0] = wheelPolar(cx, cy, r, a0), [x1, y1] = wheelPolar(cx, cy, r, a1);
      paths += `<path d="M${cx} ${cy} L${x0.toFixed(2)} ${y0.toFixed(2)} A${r} ${r} 0 0 1 ${x1.toFixed(2)} ${y1.toFixed(2)} Z" fill="${WHEEL[i].c}" stroke="rgba(0,0,0,.4)" stroke-width="1"/>`;
      const mid = a0 + seg / 2, [lx, ly] = wheelPolar(cx, cy, r * 0.64, mid);
      labels += `<text x="${lx.toFixed(2)}" y="${ly.toFixed(2)}" transform="rotate(${mid.toFixed(2)} ${lx.toFixed(2)} ${ly.toFixed(2)})" text-anchor="middle" dominant-baseline="middle" font-size="${WHEEL[i].big ? 9 : 11}" font-weight="900" fill="${WHEEL[i].niete ? "#9aa0a6" : "#1a1206"}">${esc(WHEEL[i].t)}</text>`;
    }
    return `<svg viewBox="0 0 220 220" class="amk-wheel-svg"><g id="amkWheelG">${paths}${labels}</g><circle cx="110" cy="110" r="15" fill="#0a0b0f" stroke="#e6b85c" stroke-width="2"/></svg>`;
  }
  function wheelSection() {
    const canSpin = session && viewer && Number(viewer.points || 0) >= 500;
    return `<section class="amk-store-section reveal" id="amkWheel">
      <div class="amk-store-sec-head"><h2>🎰 Glücksrad</h2><span class="amk-store-sec-count">500 ⭐ pro Dreh</span></div>
      <div class="amk-wheel-wrap">
        <div class="amk-wheel-stage"><div class="amk-wheel-pointer"></div>${buildWheelSvg()}</div>
        <div class="amk-wheel-side">
          <p class="amk-wheel-info">Dreh dein Glück und verwandle deine Punkte — mit etwas Glück sogar in einen Jackpot. <b>Jeder Dreh kostet 500 Punkte.</b></p>
          <div class="amk-wheel-result" id="amkWheelResult"></div>
          <button class="amk-store-btn amk-wheel-spin" id="amkWheelSpin" ${!canSpin ? "" : ""}>🎰 Drehen — 500 ⭐</button>
          ${!session ? `<small class="amk-wheel-hint">Zum Spielen mit Twitch einloggen.</small>` : (!canSpin ? `<small class="amk-wheel-hint">Du brauchst mindestens 500 Punkte.</small>` : "")}
        </div>
      </div>
    </section>`;
  }
  async function spinWheel() {
    if (wheelSpinning) return;
    if (!session) { startLogin(); return; }
    if (!viewer || Number(viewer.points || 0) < 500) { toast("Nicht genug Punkte — du brauchst 500.", false); return; }
    wheelSpinning = true;
    const btn = document.getElementById("amkWheelSpin"), resEl = document.getElementById("amkWheelResult");
    if (btn) { btn.disabled = true; btn.textContent = "Dreht…"; }
    if (resEl) resEl.innerHTML = "";
    let res;
    try {
      const { data, error } = await sb.rpc("store_gamble", { p_twitch_user_id: session.id, p_cost: 500 });
      if (error) throw error; res = data;
    } catch (e) { res = null; toast("Fehler: " + (e.message || e), false); }
    if (!res || !res.ok) {
      if (res && res.error) toast(res.error, false);
      wheelSpinning = false; if (btn) { btn.disabled = false; btn.textContent = "🎰 Drehen — 500 ⭐"; } return;
    }
    // Einsatz sofort sichtbar abziehen (points_left enthält Einsatz UND Gewinn -> Gewinn erst nach Animation)
    const N = WHEEL.length, seg = 360 / N, i = res.segment;
    const mid = i * seg + seg / 2, jitter = (Math.random() - 0.5) * seg * 0.5;
    const targetMod = (((360 - mid - jitter) % 360) + 360) % 360;
    const curMod = ((wheelRotation % 360) + 360) % 360;
    const delta = (targetMod - curMod + 360) % 360;
    wheelRotation += 360 * 6 + delta;
    const g = document.getElementById("amkWheelG");
    if (g) { g.style.transition = "transform 4.8s cubic-bezier(.12,.78,.2,1)"; g.style.transform = `rotate(${wheelRotation}deg)`; }
    setTimeout(() => {
      if (viewer) viewer.points = res.points_left;
      const ptsEl = document.getElementById("amkStorePts"); if (ptsEl) animateCount(ptsEl, res.points_left);
      let msg;
      if (res.physical) msg = `<div class="amk-wheel-win big">🎉 JACKPOT! Du hast <b>${esc(res.label || "einen Hauptpreis")}</b> gewonnen! Wir melden uns bei dir.</div>`;
      else if (res.points_won > 0) msg = `<div class="amk-wheel-win">🎉 <b>+${pts(res.points_won)}</b> Punkte gewonnen!</div>`;
      else msg = `<div class="amk-wheel-win loss">Leider eine Niete — viel Glück beim nächsten Dreh!</div>`;
      if (resEl) resEl.innerHTML = msg;
      wheelSpinning = false;
      if (btn) { const can = viewer && Number(viewer.points || 0) >= 500; btn.disabled = !can; btn.textContent = "🎰 Drehen — 500 ⭐"; }
    }, 4900);
  }

  function render() {
    const title = settings.store_title || "AMK Stream Store";
    const subtitle = settings.store_subtitle || "Punkte sammeln & einlösen";

    const head = `
      <header class="amk-store-header">
        <div class="amk-store-brand">
          <div class="amk-store-logo-wrap"><img src="${esc(CFG.logoUrl || "")}" alt="" class="amk-store-logo"></div>
          <div class="amk-store-brand-text"><h1>${esc(title)}</h1><p>${esc(subtitle)}</p></div>
        </div>
        <div class="amk-store-account">
          ${session ? `
            <div class="amk-store-user">
              <div class="amk-store-ava-wrap"><img src="${esc(session.avatar || "")}" alt="" class="amk-store-ava"></div>
              <div class="amk-store-user-meta">
                <strong>${esc(session.name || session.login)}</strong>
                <span class="amk-store-balance"><span class="star">⭐</span> <span id="amkStorePts">0</span> Punkte</span>
              </div>
              <button class="amk-store-btn ghost small" id="amkStoreLogout">Logout</button>
            </div>`
          : `<button class="amk-store-btn amk-store-login" id="amkStoreLogin">${TWITCH_IC} Mit Twitch einloggen</button>`}
        </div>
      </header>`;

    const catalog = activeCat === "Alle" ? items : items.filter((i) => String(i.category) === activeCat);
    // Top-Produkte = im Backend als "Top" markierte Artikel; sonst Fallback = erste 4
    const flagged = items.filter((i) => i.featured);
    const topProducts = (flagged.length ? flagged : items.slice(0, 4)).slice(0, 8);

    // Top-Produkte (Reihe wie "Top Pick" in der Vorlage)
    const topSec = topProducts.length
      ? `<section class="amk-store-section reveal">
          <div class="amk-store-sec-head"><h2>Top-Produkte</h2><span class="link" data-scroll="catalog">Alle ansehen →</span></div>
          <div class="amk-store-grid">${topProducts.map(itemCard).join("")}</div>
        </section>` : "";

    // Deine Einlösungen
    const myredSec = (session && myReds.length)
      ? `<section class="amk-store-section reveal">
          <div class="amk-store-sec-head"><h2>Deine Einlösungen</h2></div>
          <div class="amk-store-myred">${myReds.map(myRedCard).join("")}</div>
        </section>` : "";

    // Alle Produkte (Katalog mit Filter)
    const catalogSec = items.length
      ? `<section class="amk-store-section" id="amkCatalog">
          <div class="amk-store-sec-head"><h2>${activeCat === "Alle" ? "Alle Produkte" : esc(activeCat)}</h2><span class="amk-store-sec-count">${catalog.length} Artikel</span></div>
          ${catBar()}
          ${catalog.length
            ? `<div class="amk-store-grid">${catalog.map(itemCard).join("")}</div>`
            : `<div class="amk-store-empty">Keine Produkte in „${esc(activeCat)}".</div>`}
        </section>`
      : `<section class="amk-store-section" id="amkCatalog"><div class="amk-store-empty">Aktuell keine Artikel verfügbar.</div></section>`;

    // Top Gewinner (volle Breite)
    const winnersSec = sideboard()
      ? `<section class="amk-store-section reveal">${sideboard()}</section>` : "";

    root.innerHTML = `<div class="amk-store-shell">${head}`
      + heroSection()
      + recentRedemptionsSection()
      + catTiles()
      + topSec
      + wheelSection()
      + twitchSection()
      + promoSection()
      + myredSec
      + catalogSec
      + winnersSec
      + `</div>`;

    const lo = document.getElementById("amkStoreLogin"); if (lo) lo.onclick = startLogin;
    const lg = document.getElementById("amkStoreLogout"); if (lg) lg.onclick = logout;
    wheelRotation = 0; // frisches SVG -> Rotation synchronisieren
    const spinBtn = document.getElementById("amkWheelSpin"); if (spinBtn) spinBtn.onclick = spinWheel;
    root.querySelectorAll("[data-redeem]").forEach((b) => {
      b.onclick = () => redeem(b.getAttribute("data-redeem"), b.getAttribute("data-email") === "1");
    });
    root.querySelectorAll("[data-cat]").forEach((b) => {
      b.onclick = () => { activeCat = b.getAttribute("data-cat"); render(); const el = document.getElementById("amkCatalog"); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); };
    });
    root.querySelectorAll("[data-scroll]").forEach((b) => {
      b.onclick = () => { const el = document.getElementById(b.getAttribute("data-scroll") === "how" ? "amkHow" : "amkCatalog"); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); };
    });

    if (session) animateCount(document.getElementById("amkStorePts"), viewer ? viewer.points : 0);
    else lastPoints = 0;

    observeReveal();
    startCoinFx();
    if (window.__amkCoinFx) setTimeout(() => window.__amkCoinFx.resize(), 250);
  }

  function itemCard(it) {
    const canAfford = viewer && Number(viewer.points || 0) >= Number(it.price_points || 0);
    const soldOut = it.stock != null && it.stock <= 0;
    let label = "Einlösen", disabled = "";
    if (soldOut) { label = "Ausverkauft"; disabled = "disabled"; }
    else if (session && !canAfford) { label = "Zu wenig Punkte"; disabled = "disabled"; }
    return `
      <div class="amk-store-card reveal ${soldOut ? "soldout" : ""} ${canAfford && !soldOut ? "afford" : ""}">
        <div class="amk-store-card-img" style="background-image:url('${esc(it.image_url || "")}')">
          ${it.category ? `<span class="amk-store-cat">${esc(it.category)}</span>` : ""}
          ${it.stock != null ? `<span class="amk-store-stock">${it.stock} übrig</span>` : ""}
        </div>
        <div class="amk-store-card-body">
          <h3>${esc(it.name)}</h3>
          ${it.description ? `<p>${esc(it.description)}</p>` : ""}
          <div class="amk-store-card-foot">
            <span class="amk-store-price"><span class="star">⭐</span> ${pts(it.price_points)}</span>
            <button class="amk-store-btn small" data-redeem="${esc(it.id)}" data-email="${it.requires_email ? "1" : "0"}" ${disabled}>${label}</button>
          </div>
        </div>
      </div>`;
  }

  /* ---------- Init ---------- */
  async function init() {
    root.innerHTML = `<div class="amk-store-shell">${skeletons()}</div>`;
    await handleRedirect();
    if (!session) { try { session = JSON.parse(localStorage.getItem(LS_KEY) || "null"); } catch (e) {} }
    await Promise.all([loadSettings(), loadItems(), loadRecentRedemptions()]);
    await loadViewer();   // erst eigenen Zuschauer-Eintrag sicherstellen …
    await Promise.all([loadTop(), loadMyRedemptions()]);   // … dann Rangliste + eigene Einlösungen
    render();
  }
  init();
})();
